import { useEffect } from 'react';

interface UseScrollToSelectedRowProps {
  selectedIds: number[];
  scrollToSelected: boolean;
  scrollToIndex: (index: number, options?) => void;
  containerRef: React.RefObject<HTMLElement>;
}

export function useScrollToSelectedRow({
  selectedIds,
  scrollToSelected,
  scrollToIndex,
  containerRef,
}: UseScrollToSelectedRowProps) {
  useEffect(() => {
    if (!scrollToSelected || !selectedIds?.length) {
      return;
    }

    const lastSelectedId = selectedIds.at(-1);
    if (lastSelectedId == null) {
      return;
    }

    const rowEl = document.getElementById(getRowElementId(lastSelectedId));
    const container = containerRef.current;

    // If the row is not rendered, scroll to it
    if (!rowEl) {
      scrollToIndex(lastSelectedId, { align: 'center' });
      return;
    }

    // If the row is rendered, ensure it's visible
    if (container && !isElementFullyVisible(rowEl, container)) {
      scrollToIndex(lastSelectedId, { align: 'center' });
    }
  }, [selectedIds, scrollToSelected, scrollToIndex]);
}

const getRowElementId = (id: string | number) => `rmtable-body-row-${id}`;

const isElementFullyVisible = (element: HTMLElement, container: HTMLElement): boolean => {
  const elRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return elRect.top >= containerRect.top && elRect.bottom <= containerRect.bottom;
};
